module.exports = __webpack_public_path__ + "images/inbox/inbox-cta-icon.png";